import React from 'react'
import Highlight, { defaultProps, Language } from 'prism-react-renderer'
import Theme from 'prism-react-renderer/themes/nightOwl'

interface HighlightPros {
  code: string
  language: Language
  className?: string
}


const Highlighter = ({ code, language, className }: HighlightPros) => {
  return (
    <div className={`${className} text-sm rounded`}>
      <Highlight {...defaultProps} code={code} language={language} theme={Theme}>
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre className={`${className} overflow-auto rounded`} style={style}>
            {tokens.map((line: any[], i: number) => (
              <div {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  )
}

export default Highlighter
